export default {
  NOT_FOUND: 'notFound',
  UNPROCESSABLE_ENTITY: 'unprocessableEntity',
  ACCEPTED: 'accepted',
  OK: 'ok',
};



// WEBPACK FOOTER //
// ./src/screens/Status/config/defaultStatus.js